export enum InsuranceBlockEvents {
  RECALCULATE_INSURANCE = 'recalculate_insurance',
}
